import React, { useEffect, useRef, useState } from 'react';
import rightImage  from '../../assets/tailwind.config.png';
import banner from '../../assets/Banner.png'
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import step1_1 from '../../assets/step1_1.png'
import step1_2_1 from '../../assets/step1_2_1.png'
import step1_2 from '../../assets/step1_2.png'
import step1_3 from '../../assets/step1_3.png'
import step1_4 from '../../assets/step1_4.png'
import step1_5 from '../../assets/step1_5.png'
import step1_6 from '../../assets/step1_6.png'
import step1_7 from '../../assets/step1_7.png'
import step1_8 from '../../assets/step1_8.png'
import ZynthWorks, { Slide } from './ZynthWorks';
const slides1: Slide[] = [
  {
    imageUrl: step1_1,
    dotPosition: { top: "39%", left: "33%" },
    caption: "1. Click on Text Box and Enter your presentation context",
  },
  {
    imageUrl:step1_2,
    dotPosition: { top: "65%", left: "40%" },
    caption:"2. OR upload a document."
  },
  {
    imageUrl:step1_2_1 ,
    dotPosition: { top: "80%", left: "51%" },
    caption: '3. Click "Submit" to view presentation options.',
    
  },
  {
    imageUrl: step1_3,
    dotPosition: { top: "23%", left: "30%" },
    caption: '4. Enter your "Reference Web URL"',
  },
  {
    imageUrl: step1_4,
    dotPosition: { top: "40%", left: "70%" },
    caption: '5. Select "Branding Colors" for the presentation.',
  },
  {
    imageUrl: step1_5,
    dotPosition: { top: "60%", left: "60%" },
    caption: '6.Save changes after picking colours.',
    
  },
  {
    imageUrl: step1_6,
    dotPosition: { top: "58%", left: "30%" },
    caption: '7. Choose a "Theme" of your presentation.',
  },
  {
    imageUrl: step1_7,
    dotPosition: { top: "78%", left: "50%" },
    caption: '8. Adjust "Creativity" based on your requirements.',
  },
  {
    imageUrl: step1_8,
    dotPosition: { top: "89%", left: "50%" },
    caption: '9. Click on "Generate Presentation"',
  
  },
];
const Heading: React.FC = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState('');
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setVideoSrc('https://d2zu6flr7wd65l.cloudfront.net/uploads/Copy+of+17th+Feb+New+Zynth+Demo+Mobile+Video.mp4');
      } else {
        setVideoSrc('');
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isModalOpen && videoRef.current) {
      videoRef.current.play().catch((error) => console.error('Video play failed:', error));
    }
  }, [isModalOpen]);

  const closeModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsModalOpen(false);
  };

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
const handleInstallClick = () => {
  const url = "https://workspace.google.com/marketplace/app/zynthai_%E2%80%93_ai_slide_builder_and_editor/704273243272?flow_type=2";
  // @ts-ignore
  if (typeof window.gtag_report_conversion === 'function') {
    // @ts-ignore
    window.gtag_report_conversion(url);
  } else {
    window.open(url, '_blank');
  }
};

  return (
    <div className="w-full bg-gradient-to-r from-green-600 via-teal-500 to-blue-600 py-20 px-6 md:px-16 ">
      <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center justify-between gap-10 mt-10">
      
        <div className="w-full md:w-[40%] text-left space-y-6">
          <h1 className="text-3xl md:text-4xl font-bold text-white leading-tight">
            Turn Simple Text Into <br />
            <span className="text-white">Stunning Google Slides</span> <br />
            in Seconds
          </h1>
          <p className="text-white font-medium text-base md:text-lg">
            An AI presentation maker built for professionals. From project reports and proposals to pitch decks, create powerpoint presentations instantly with branded design and storytelling.
          </p>

          <ul className="text-white space-y-2">
            <li className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-white" />
              No design skills needed
            </li>
            <li className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-white" />
              Save hours every week
            </li>
            <li className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-white" />
              Works directly inside Google Slides™
            </li>
          </ul>

          <div className="flex flex-col sm:flex-row gap-4 pt-4">
     <button
  onClick={handleInstallClick}
  className="px-6 py-3 bg-white text-[#3667B2] font-semibold rounded-md hover:bg-blue-600 hover:text-white transition duration-300 active:scale-95"
>
  Install Zynth.ai for Google Slides
</button>

            <button
              onClick={() => setIsModalOpen(true)}
              className="px-6 py-3 border border-white text-white font-semibold rounded-md hover:bg-white hover:text-[#3667B2] transition duration-300 active:scale-95"
            >
              Watch Demo
            </button>
          </div>
        </div>

        
        <div className="w-full md:w-[55%] h-[60vh]">
          <img
            src={banner}
            alt="Zynth Google Slides"
            className="w-full h-[90%] rounded-lg shadow-xl object-contain"
          />
          {/* <ZynthWorks slides={slides1}  bgColor="bg-[#3667B2]"/> */}
        </div>
      </div>

      {isModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className="bg-white rounded-lg shadow-lg w-[90%] md:w-[60%] lg:w-[80%] lg:h-[80%] xl:w-[90%] xl:h-[85%] relative flex items-center justify-center"
            onClick={stopPropagation}
          >
            <button
              onClick={(e) => closeModal(e)}
              className="absolute top-2 right-2 text-gray-700 hover:text-gray-900 text-2xl font-bold z-50"
            >
              &times;
            </button>
            <video
              ref={videoRef}
              controls
              className="w-full h-full rounded-md object-contain z-10"
            >
              <source
                src={
                  videoSrc ||
                  'https://d2zu6flr7wd65l.cloudfront.net/uploads/13th+Feb+Zynth+Demo+Web+Video.mp4'
                }
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </div>
  );
};

export default Heading;
